import React from 'react';

/**
 * Lazy-load operator mailbox sync diagnostics route only when internal controls are enabled.
 */
export function maybeRenderOperatorMailboxSyncDiagnosticsRoute(): React.ReactNode {
  if (process.env.REACT_APP_ENABLE_INTERNAL_CONTROLS !== 'true') {
    return null;
  }
  // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
  const Page = require('../pages/OperatorMailboxSyncDiagnosticsPage').default as React.ComponentType;
  return <Page />;
}
